const constants = {
  emissions: {
    factsheet: {
      type: 'factsheet',
      name: 'Emissions_factsheet',
      link: 'https://www.dropbox.com/sh/11p7ibbd06thskq/AADn3A2aCCHBhs89RFk54_MJa?dl=0&preview=Emissions_factsheet.pdf',
    }
  },
  forecast: {
    factsheet: {
      type: 'factsheet',
      name: 'Forecast_factsheet',
      link: 'https://www.dropbox.com/sh/11p7ibbd06thskq/AADn3A2aCCHBhs89RFk54_MJa?dl=0&preview=Forecast_factsheet.pdf',
    }
  },
  retina: {
    factsheet: {
      type: 'factsheet',
      name: 'Retina_factsheet',
      link: 'https://www.dropbox.com/sh/11p7ibbd06thskq/AADn3A2aCCHBhs89RFk54_MJa?dl=0&preview=Retina_factsheet.pdf',
    },
  },
  atmo: {
    factsheet: {
      type: 'factsheet',
      name: 'Atmo_factsheet',
      link: 'https://www.dropbox.com/sh/11p7ibbd06thskq/AADn3A2aCCHBhs89RFk54_MJa?dl=0&preview=Atmo_factsheet.pdf'
    },
    manual: {
      type: "user's manual",
      name: "user's manual",
      link: 'https://drive.google.com/file/d/1dql6nzOCfPdNW_5FAEptegllR67T4Vtn/view',
    },
  }
};

export default constants;



// WEBPACK FOOTER //
// ./src/pages/products/constants.js